import React from 'react';
import { CommonIconProps } from './Icon';

const ChevronLeftIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3551 0.502102C17.6856 -0.167367 16.6002 -0.167367 15.9307 0.502102L6.25108 10.1817C5.24687 11.1859 5.24687 12.8141 6.25108 13.8183L15.9307 23.4979C16.6002 24.1673 17.6856 24.1673 18.3551 23.4979C19.0245 22.8285 19.0245 21.743 18.3551 21.0735L9.28153 12L18.3551 2.92647C19.0245 2.25699 19.0245 1.17157 18.3551 0.502102Z"
      fill={color}
    />
  </>
);

export default ChevronLeftIcon;
